// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/event/event_service.proto (package api.v1.event, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { EventSchema } from "./event_types_pb";
import { file_v1_event_event_types } from "./event_types_pb";
import type { AddCollaboratorRequestSchema, AddCollaboratorResponseSchema, CancelRegistrationRequestSchema, CheckInAttendeeRequestSchema, CheckInAttendeeResponseSchema, CreateEventRequestSchema, CreateEventResponseSchema, CreateImageRequestSchema, DeleteEventRequestSchema, GenerateEventIdRequestSchema, GenerateEventIdResponseSchema, GetAttendeeQRCodeRequestSchema, GetAttendeeQRCodeResponseSchema, GetCollaboratorRequestSchema, GetCollaboratorResponseSchema, GetEventAttendanceRequestSchema, GetEventAttendanceResponseSchema, GetEventRequestSchema, GetRegistrationStatusRequestSchema, GetRegistrationStatusResponseSchema, GetUserRegisteredEventsRequestSchema, GetUserRegisteredEventsResponseSchema, IsOrgVerifiedRequestSchema, IsOrgVerifiedResponseSchema, IsSavedEventRequestSchema, IsSavedEventResponseSchema, ListAttendeesRequestSchema, ListAttendeesResponseSchema, ListCollaborationsByEntityRequestSchema, ListCollaborationsByEntityResponseSchema, ListEventCollaboratorsRequestSchema, ListEventCollaboratorsResponseSchema, ListPendingCollaborationsRequestSchema, ListPendingCollaborationsResponseSchema, RegisterEventRequestSchema, RegisterEventResponseSchema, RemoveCollaboratorRequestSchema, SearchEventsRequestSchema, SearchEventsResponseSchema, SearchUsersAndOrgsRequestSchema, SearchUsersAndOrgsResponseSchema, UpdateCollaboratorRequesteeStatusRequestSchema, UpdateCollaboratorRequestSchema, UpdateEventRequestSchema } from "./event_requests_pb";
import { file_v1_event_event_requests } from "./event_requests_pb";

/**
 * Describes the file v1/event/event_service.proto.
 */
export const file_v1_event_event_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_protobuf_empty, file_v1_event_event_types, file_v1_event_event_requests]);

/**
 * @generated from service api.v1.event.EventService
 */
export const EventService: GenService<{
  /**
   * @generated from rpc api.v1.event.EventService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateEventRequestSchema;
    output: typeof CreateEventResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetEventRequestSchema;
    output: typeof EventSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * ==================== UNIFIED SEARCH ====================
   * Single search method supporting both community and beyond modes
   *
   * @generated from rpc api.v1.event.EventService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchEventsRequestSchema;
    output: typeof SearchEventsResponseSchema;
  },
  /**
   * ==================== EVENT MANAGEMENT ====================
   *
   * @generated from rpc api.v1.event.EventService.GenerateId
   */
  generateId: {
    methodKind: "unary";
    input: typeof GenerateEventIdRequestSchema;
    output: typeof GenerateEventIdResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.CreateImage
   */
  createImage: {
    methodKind: "unary";
    input: typeof CreateImageRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.IsSavedEvent
   */
  isSavedEvent: {
    methodKind: "unary";
    input: typeof IsSavedEventRequestSchema;
    output: typeof IsSavedEventResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.RegisterEvent
   */
  registerEvent: {
    methodKind: "unary";
    input: typeof RegisterEventRequestSchema;
    output: typeof RegisterEventResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.CancelRegistration
   */
  cancelRegistration: {
    methodKind: "unary";
    input: typeof CancelRegistrationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.GetRegistrationStatus
   */
  getRegistrationStatus: {
    methodKind: "unary";
    input: typeof GetRegistrationStatusRequestSchema;
    output: typeof GetRegistrationStatusResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.GetUserRegisteredEvents
   */
  getUserRegisteredEvents: {
    methodKind: "unary";
    input: typeof GetUserRegisteredEventsRequestSchema;
    output: typeof GetUserRegisteredEventsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.GetAttendeeQRCode
   */
  getAttendeeQRCode: {
    methodKind: "unary";
    input: typeof GetAttendeeQRCodeRequestSchema;
    output: typeof GetAttendeeQRCodeResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.CheckInAttendee
   */
  checkInAttendee: {
    methodKind: "unary";
    input: typeof CheckInAttendeeRequestSchema;
    output: typeof CheckInAttendeeResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.GetEventAttendance
   */
  getEventAttendance: {
    methodKind: "unary";
    input: typeof GetEventAttendanceRequestSchema;
    output: typeof GetEventAttendanceResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.ListAttendees
   */
  listAttendees: {
    methodKind: "unary";
    input: typeof ListAttendeesRequestSchema;
    output: typeof ListAttendeesResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.IsOrgVerified
   */
  isOrgVerified: {
    methodKind: "unary";
    input: typeof IsOrgVerifiedRequestSchema;
    output: typeof IsOrgVerifiedResponseSchema;
  },
  /**
   * ==================== COLLABORATOR SERVICE METHODS ====================
   *
   * @generated from rpc api.v1.event.EventService.AddCollaborator
   */
  addCollaborator: {
    methodKind: "unary";
    input: typeof AddCollaboratorRequestSchema;
    output: typeof AddCollaboratorResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.GetCollaborator
   */
  getCollaborator: {
    methodKind: "unary";
    input: typeof GetCollaboratorRequestSchema;
    output: typeof GetCollaboratorResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.ListCollaborationsByEntity
   */
  listCollaborationsByEntity: {
    methodKind: "unary";
    input: typeof ListCollaborationsByEntityRequestSchema;
    output: typeof ListCollaborationsByEntityResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.ListEventCollaborators
   */
  listEventCollaborators: {
    methodKind: "unary";
    input: typeof ListEventCollaboratorsRequestSchema;
    output: typeof ListEventCollaboratorsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.ListPendingCollaborations
   */
  listPendingCollaborations: {
    methodKind: "unary";
    input: typeof ListPendingCollaborationsRequestSchema;
    output: typeof ListPendingCollaborationsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.RemoveCollaborator
   */
  removeCollaborator: {
    methodKind: "unary";
    input: typeof RemoveCollaboratorRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.SearchUsersAndOrgs
   */
  searchUsersAndOrgs: {
    methodKind: "unary";
    input: typeof SearchUsersAndOrgsRequestSchema;
    output: typeof SearchUsersAndOrgsResponseSchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.UpdateCollaborator
   */
  updateCollaborator: {
    methodKind: "unary";
    input: typeof UpdateCollaboratorRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc api.v1.event.EventService.UpdateCollaboratorRequesteeStatus
   */
  updateCollaboratorRequesteeStatus: {
    methodKind: "unary";
    input: typeof UpdateCollaboratorRequesteeStatusRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_event_event_service, 0);

